import { HStack } from '@cbhq/cds-web/layout';
import { Link, TextLegal } from '@cbhq/cds-web/typography';

export function Footer() {
  return (
    <HStack
      alignItems="center"
      background="bg"
      flexWrap="wrap"
      gap={1}
      justifyContent="space-between"
      minHeight={52}
      padding={2}
    >
      <HStack>
        <TextLegal as="span" color="fgMuted">
          © {new Date().getFullYear()} Coinbase
        </TextLegal>
      </HStack>
      <HStack gap={2}>
        <TextLegal as="span">
          <Link href={process.env.NEXT_PUBLIC_TERMS_URL} color="fgMuted" openInNewWindow>
            Terms of Service
          </Link>
        </TextLegal>
        <TextLegal as="span">
          <Link href={process.env.NEXT_PUBLIC_PRIVACY_URL} color="fgMuted" openInNewWindow>
            Privacy Policy
          </Link>
        </TextLegal>
      </HStack>
    </HStack>
  );
}
